import React from "react";
import "./App.css";
import RouterComponent from "../src/routerComponents/RouterComponent";
import {
  ApplicationStatusProvider,
  FormProvider,
  LoanOfficerProvider,
  ReviewMatrixProvider,
  TestApplicationProvider,
  UserRoleProvider,
  OriginatorListProvider,
  PropertyDisclosureIssueProvider
} from "./context/FormContext";

function App() {
  return (
    <>
      <FormProvider>
        <ReviewMatrixProvider>
          <LoanOfficerProvider>
            <ApplicationStatusProvider>
              <TestApplicationProvider>
                <UserRoleProvider>
                  <OriginatorListProvider>
                    <PropertyDisclosureIssueProvider>
                      <RouterComponent />
                    </PropertyDisclosureIssueProvider>
                  </OriginatorListProvider>
                </UserRoleProvider>
              </TestApplicationProvider>
            </ApplicationStatusProvider>
          </LoanOfficerProvider>
        </ReviewMatrixProvider>
      </FormProvider>
    </>
  );
}

export default App;
